(function() {
  'use strict';

  angular.module('ringbaPortal').component('userTasks', {
    controller: UserTasksController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/user-tasks/user-tasks.view.html'
  });

  function UserTasksController(
    $stateParams,
    $timeout,
    accountsService,
    userTasksService,
    utils
  ) {
    'ngInject';

    const vm = this;

    const tabIndexForStatus = {
      'open': 0,
      'pending': 1,
      'completed': 2
    };

    // This will have 'status' as the property and then the count as the value
    vm.tasksCount = {};
    vm.reloadData = {
      'open': false,
      'pending': false,
      'completed': false
    };
    vm.activeTab = 0;
    vm.textsTranslations = {
      open: {
        title: 'OPEN_TASKS',
        loading: 'LOADING_OPEN_TASKS',
        empty: 'NONE_OPEN_TASKS'
      },
      pending: {
        title: 'PENDING_TASKS',
        loading: 'LOADING_PENDING_TASKS',
        empty: 'NONE_PENDING_TASKS'
      },
      completed: {
        title: 'COMPLETED_TASKS',
        loading: 'LOADING_COMPLETED_TASKS',
        empty: 'NONE_COMPLETED_TASKS'
      }
    };


    vm.$onInit = onInit;
    vm.setTaskCount = setTaskCount;
    vm.reloadDataForStatus = reloadDataForStatus;
    vm.showTab = showTab;
    vm.resetHighlightedTask = resetHighlightedTask;

    function onInit() {
      _showTaskFromUrlParam();
    }

    function setTaskCount(count, taskStatus) {
      vm.tasksCount[taskStatus] = count;
    }

    function reloadDataForStatus(status) {
      vm.reloadData[status] = true;
      $timeout(function() {
        vm.reloadData[status] = false;
      }, 10);
    }

    function showTab(status, taskId) {
      vm.activeTab = tabIndexForStatus[status];
      vm.highlightTaskInTab = taskId;
    }

    function resetHighlightedTask() {
      $timeout(function() {
        vm.highlightTaskInTab = undefined;
      }, 1500);
    }

    function _showTaskFromUrlParam() {
      vm.showTaskFromLinkId = $stateParams && $stateParams.taskid;
      if (vm.showTaskFromLinkId) {
        _getTaskStatus(vm.showTaskFromLinkId);
      }
    }

    function _getTaskStatus(taskId) {
      userTasksService.getTaskDetails(accountsService.currentAccountId, taskId)
        .then(_activateTaskStatusTab)
        .catch(utils.errorHandler);
    }

    function _activateTaskStatusTab(response) {
      const task = response.data.job;
      showTab(task.status, task.id);
    }

  }
})();
